import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBpiVCES6kFHY8l3MFbbJd2mpaQ39T14iw",
  authDomain: "edyt-frontend.firebaseapp.com",
  projectId: "edyt-frontend",
  storageBucket: "edyt-frontend.firebasestorage.app",
  messagingSenderId: "171995454687",
  appId: "1:171995454687:web:a5c85bb732edcd88849d6a"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);

export default app;
